<script>
export default {
  props: {
    list: {
      type: Array,
      required: true,
    },
    orderSecondType: {
      type: String,
      default: 'deposit',
    }
  },
  data() {
    return {
      submitData: {
        priceId: '',
        point: '',
        price: '',
        customTitle: '',
        costPrice: null
      },
    }
  },
  computed: {
    depositItem() {
      if (this.submitData.priceId === 'custom') {
        const { customTitle, point, price, costPrice } = this.submitData
        const customText = this.orderSecondType === 'deposit' ? '自訂方案' : ''
        return {
          title: `${customText}${customTitle}`,
          canBuy: true,
          point,
          price,
          costPrice
        }
      }
      return this.list.find(({ uuid }) => uuid === this.submitData.priceId) || {}
    },
    submitRules() {
      return {
        point: [
          {
            required: true,
            type: 'number',
            min: 0,
            message: '請輸入點數',
            trigger: 'blur',
          },
        ],
        price: [
          {
            required: true,
            type: 'number',
            min: 0,
            message: '請輸入價格',
            trigger: 'blur',
          },
        ],
        customTitle: {
          required: true,
          message: '請輸入備註',
          trigger: 'blur',
        },
      }
    },
    /**
     * @description 決定儲值or抵扣
     */
    typeText() {
      const textRoute = {
        'deposit': '儲值',
        'deduct': '抵扣'
      }
      return textRoute[this.orderSecondType]?? ''
    }
  },
  mounted() {
    if(this.orderSecondType === 'deduct'){
      this.$set(this.submitData, 'priceId', 'custom')
    }
  },
  watch: {
    submitData: {
      handler: 'onEmitUpdate',
      deep: true,
    },
  },
  methods: {
    onEmitUpdate() {
      const { title, point, price, canBuy, id, uuid, costPrice } = this.depositItem
      if (!title && this.orderSecondType === 'deposit') return

      this.$emit('update', {
        title,
        point,
        price,
        priceId: uuid ?? null,
        canBuy,
        qty: 1,
        type: 'deposit-plan',
        id,
        costPrice
      })
    },
  },
}
</script>
<template>
  <div>
    <el-form style="margin-bottom: 30px" :model="submitData" :rules="submitRules" label-position="top"
      class="el-form-item--normal-margin el-form-item--white-bg">
      <el-form-item v-if="orderSecondType === 'deposit'" prop="priceId" :label="`${typeText}方案`">
        <el-select v-model="submitData.priceId">
          <el-option v-for="item in list" :key="item.id" :value="item.uuid"
            :label="`${item.title}  ${item.point}點 / ${item.price}元`">
            {{ item.title }} {{ item.point }}點 / {{ item.price }}元
          </el-option>
          <el-option value="custom" label="自訂"> </el-option>
        </el-select>
      </el-form-item>
      <template v-if="submitData.priceId === 'custom'">
        <el-row :gutter="20">
          <el-col :span="12" v-if="orderSecondType === 'deposit'">
            <el-form-item prop="point" :label="`${typeText}點數`">
              <el-input v-model.number="submitData.point">
                <template v-slot:append>點</template>
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="orderSecondType === 'deposit'">
            <el-form-item prop="price" label="售價">
              <el-input v-model.number="submitData.price">
                <template v-slot:append>元</template>
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24" v-if="orderSecondType === 'deduct'">
            <el-form-item prop="price" label="抵扣">
              <el-input v-model.number="submitData.price">
                <template v-slot:append>點</template>
              </el-input>
            </el-form-item>
          </el-col>
          <el-col v-if="orderSecondType === 'deposit'" :span="24">
            <el-form-item label="成本價">
              <el-input v-model.number="submitData.costPrice">
                <template v-slot:append>元</template>
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item prop="customTitle" label="備註">
              <el-input v-model="submitData.customTitle"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </template>
    </el-form>
  </div>
</template>
